import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../features/authSlice'; // Ye action sab kuch clear karega
import { removeToken } from '../services/LocalStorageService';

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Sab kuch clear kar do
    dispatch(logout());        // Ye dono kaam karega: token + userInfo remove
    removeToken();             // Agar tera LocalStorageService alag se token save karta hai
    navigate('/login', { replace: true }); // Login page pe bhej do
  }, [dispatch, navigate]);

  // Optional: Loading message dikha sakta hai
  return (
    <div style={{
      textAlign: 'center',
      marginTop: '100px',
      fontSize: '1.5rem',
      color: '#004aad'
    }}>
      Logging you out...
    </div>
  );
};

export default Logout;